import { FeatureConfiguration } from "..";

import { reducer } from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.enrolment = reducer;
}
